import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ProgramService } from '../../services/program.service';
import { BudgetChangesService } from '../../services/budget-changes.service';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/combineLatest';
import { NavBarService } from 'app/services/nav-bar.service';

@Component({
  selector: 'app-general-budget-changes',
  templateUrl: './general-budget-changes.component.html',
  styleUrls: ['./general-budget-changes.component.scss'],
})
export class GeneralBudgetChangesComponent implements OnInit {
  texts: any;
  ready: boolean = false;
  lowerChanges: any[];
  program: any = { naam: '', weergavenummer: 0 };
  selectedTab: number = 1;

  constructor(
    private route: ActivatedRoute,
    private changesService: BudgetChangesService
  ) {}

  ngOnInit() {
    const lower = this.route.parent.params.switchMap((params: Params) =>
      this.changesService.getLower(0)
    );

    lower.subscribe(a => {
      this.ready = true;
      this.lowerChanges = a;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/general-budget-changes/general-budget-changes.component.ts